<template>
  <div class="wp-history-external-comment">
    <span class="workpermit-content-slot__history-label">{{ $t('workPermit.externalCommentsHistoryLabel') }}</span>
    <pre class="workpermit-content-slot__history-pre">{{ text }}</pre>
  </div>
</template>

<script>
export default {
  name: 'WpHistoryExternalCommentBlock',
  props: {
    text: {
      default: null,
    },
  },
}
</script>
